import { api } from "../../../config/api";

export const getAllUsersApi = async (token, includeDeleted = false) => {
  return await api.get(`/api/users${includeDeleted ? '?include_deleted=true' : ''}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const createUserApi = async (token, userData) => {
  return await api.post("/api/users", userData, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const updateUserApi = async (token, id, updateData) => {
  return await api.put(`/api/users/${id}`, updateData, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const deleteUserApi = async (token, id) => {
  return await api.delete(`/api/users/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
